import { Employee } from "../../../../types/ganttChart";
import VerticalTextRow from "../VerticalTextRow";
import ganttChartStyles from "../../../../styles/ganttChart/ganttChart.module.css";
import KpiWrapper from "../../KpiWrapper";
import VerticalGanttChartTransportationIcon from "../VerticalGanttChartTransportationIcon";
import ViolationChip from "../../../UI/chips/ViolationChip";
import React from "react";
import { useAppSelector } from "../../../../store/hooks";
import VerticalOverlayForBlockedShift from "../VerticalOverlayForBlockedShift";
import labels from "../../../../utils/labels";
import { transportTypeAt } from "../../../../utils/transportSegmentUtil";
import HoverBoxAnchor from "../../../UI/hoverBox/HoverBoxAnchor";
import { ganttChartVerticalValues } from "../../../../utils/ganttChartValues";

const KpiRows = ({ employees }: { employees: Employee[] }) => {
  const { verticalColumnWidth } = useAppSelector(
    (state) => state.ganttChartSlice,
  );

  const isCompact = verticalColumnWidth < ganttChartVerticalValues.kpiCompactThreshold;
  const showTransport = verticalColumnWidth > ganttChartVerticalValues.kpiTransportMinWidth;

  const getKpiArray = () =>
    employees.map((employee, idx) => {
      const continuity =
        Math.round(employee.shiftSchedule.kpi.continuity * 10) / 10;
      const distanceKm = Math.round(
        employee.shiftSchedule.kpi.travelDistanceInMeters / 1000,
      );
      const violationCount = employee.shiftSchedule.kpi.violations?.length ?? 0;

      return (
        <React.Fragment key={`fragment-${idx}`}>
          <div
            role="group"
            aria-label={employee.fullName}
            className="flex gap-[var(--spacing-xs)] items-center w-full"
          >
            {employee.shiftSchedule.kpi.continuity != null && (
              <HoverBoxAnchor
                tooltipText={labels.kpiContinuityTooltip(continuity)}
              >
                <KpiWrapper
                  id="continuity"
                  value={continuity}
                  showColoredChip
                  compact={isCompact}
                />
              </HoverBoxAnchor>
            )}
            {showTransport && (
              <HoverBoxAnchor
                tooltipText={labels.kpiTransportTooltip(distanceKm)}
              >
                <KpiWrapper
                  id="distance"
                  value={distanceKm}
                  compact={isCompact}
                >
                  <VerticalGanttChartTransportationIcon
                    type={transportTypeAt(
                      employee.transportationType,
                      employee.shiftStartTime,
                    )}
                    color="var(--col-interaction-secondary)"
                    size={10}
                  />
                </KpiWrapper>
              </HoverBoxAnchor>
            )}
            {violationCount > 0 && (
              <HoverBoxAnchor
                tooltipText={labels.kpiViolationsTooltip(violationCount)}
              >
                <KpiWrapper
                  id="violations"
                  value={violationCount}
                  compact={isCompact}
                >
                  <ViolationChip />
                </KpiWrapper>
              </HoverBoxAnchor>
            )}
          </div>
          <VerticalOverlayForBlockedShift employee={employee} />
        </React.Fragment>
      );
    });

  return (
    <section
      className={ganttChartStyles.verticalTextRow}
      style={{ pointerEvents: "auto" }}
    >
      <VerticalTextRow title="" array={getKpiArray()} />
    </section>
  );
};

export default KpiRows;
